<template>
  <div class="task-detail-skeleton" data-testid="task-detail__loading-skeleton">
    <div class="task-detail-skeleton__card">
      <div class="task-detail-skeleton__nav">
        <div class="task-detail-skeleton__back">
          <span class="task-detail-skeleton__block task-detail-skeleton__block--icon" />
          <span class="task-detail-skeleton__block task-detail-skeleton__block--back-text" />
        </div>
        <div class="task-detail-skeleton__nav-actions">
          <span class="task-detail-skeleton__block task-detail-skeleton__block--icon-btn" />
          <span class="task-detail-skeleton__block task-detail-skeleton__block--segmented" />
        </div>
      </div>

      <div class="task-detail-skeleton__header">
        <div class="task-detail-skeleton__meta">
          <span class="task-detail-skeleton__block task-detail-skeleton__block--chip" />
          <span class="task-detail-skeleton__block task-detail-skeleton__block--chip task-detail-skeleton__block--chip-wide" />
        </div>
        <div class="task-detail-skeleton__actions">
          <span
            v-for="actionIndex in 3"
            :key="`task-detail-skeleton-action-${actionIndex}`"
            class="task-detail-skeleton__block task-detail-skeleton__block--action"
          />
        </div>
      </div>

      <div class="task-detail-skeleton__title">
        <span class="task-detail-skeleton__block task-detail-skeleton__block--title" />
        <span class="task-detail-skeleton__block task-detail-skeleton__block--title-sub" />
      </div>

      <div class="task-detail-skeleton__metrics">
        <span
          v-for="metricIndex in 4"
          :key="`task-detail-skeleton-metric-${metricIndex}`"
          class="task-detail-skeleton__block task-detail-skeleton__block--metric"
        />
      </div>

      <div class="task-detail-skeleton__tabs">
        <span
          v-for="tabIndex in 4"
          :key="`task-detail-skeleton-tab-${tabIndex}`"
          class="task-detail-skeleton__block task-detail-skeleton__block--tab"
          :class="{ 'task-detail-skeleton__block--tab-active': tabIndex === 1 }"
        />
      </div>

      <div class="task-detail-skeleton__summary">
        <div class="task-detail-skeleton__summary-main">
          <span class="task-detail-skeleton__block task-detail-skeleton__block--panel" />
          <span class="task-detail-skeleton__block task-detail-skeleton__block--panel task-detail-skeleton__block--panel-tall" />
        </div>
        <div class="task-detail-skeleton__summary-side">
          <span
            v-for="sideIndex in 3"
            :key="`task-detail-skeleton-side-${sideIndex}`"
            class="task-detail-skeleton__block task-detail-skeleton__block--side-card"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './TaskDetailSkeleton.scss';

export default {
  name: 'TaskDetailSkeleton',
};
</script>
